<template>
<div class="reviews-block">
    <div v-for="fullStar in fullStars" class="rating-marker"></div>
    <div v-if="hasHalfStar" class="rating-marker rating-marker-half"></div>
    <div v-for="emptyStar in emptyStars" class="rating-marker rating-marker-empty"></div>
</div>
</template>
<script>
export default {
    props: ['rating'],
    computed: {
        fullStars: function() {
            return parseInt( this.rating );
        },
        hasHalfStar: function() {
            return String(this.rating).includes('.');
        },
        emptyStars: function() {
            return ( this.hasHalfStar ) ? (this.stars - (this.fullStars + 1)) : (this.stars - this.fullStars);
        }

    },
    data() {
        return {
            stars: 5
        }
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/quiz-campaign/components/content-blocks/reviews-block.vue